export const VDO_RGX = /^(http:\/\/|https:\/\/)(player\.vimeo\.com|vimeo\.com|youtu\.be|www\.youtube\.com)\/([\w/]+)([?].*)?$/igm
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
export const NAME_REGEX = /^\S.{1,}\S$/
export const PASSWORD_REGEX = /^\S.{4,28}\S$/
